import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@util/utils";
import CreatePurchaseDialog from "@clubInventory/purchase/dialog/CreatePurchaseDialog";
import PurchaseInspectionAndStorageDialog from "@clubInventory/purchase/dialog/PurchaseInspectionAndStorageDialog";
import PurchaseOrderCloseDialog from "@clubInventory/purchase/dialog/PurchaseOrderCloseDialog";

const CREATE_PURCHASE_DIALOG = "CreatePurchaseDialog";
const PURCHASE_INSPECTION_AND_STORAGE_DIALOG = "PurchaseInspectionAndStorageDialog";
const PURCHASE_ORDER_CLOSE_DIALOG = "PurchaseOrderCloseDialog";

// 功能：進貨相關 Dialog 管理器（統一開關與傳遞 refresh/sourceData）
const PurchaseDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleDialogClose = useCallback(
		() => {
			setOpenDialog(null);
			setSourceData(null);
			refreshRef.current = null;
		},
		// eslint-disable-next-line
		[],
	);

	const doRefresh = (...arg) => {
		const fn = refreshRef.current;
		if (!isFunction(fn)) return;
		setTimeout(() => fn(...arg), 5);
	};

	useImperativeHandle(
		ref,
		() => ({
			// 開啟新增進貨單彈窗
			openCreatePurchaseDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(CREATE_PURCHASE_DIALOG);
			},
			// 開啟進貨單驗收及入庫彈窗
			openPurchaseInspectionAndStorageDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(PURCHASE_INSPECTION_AND_STORAGE_DIALOG);
			},
			// 開啟進貨單結單彈窗
			openPurchaseOrderCloseDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(PURCHASE_ORDER_CLOSE_DIALOG);
			},
			// 關閉彈窗
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[handleDialogClose],
	);

	return (
		<React.Fragment>
			<CreatePurchaseDialog open={isEqual(openDialog, CREATE_PURCHASE_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} />
			<PurchaseInspectionAndStorageDialog
				open={isEqual(openDialog, PURCHASE_INSPECTION_AND_STORAGE_DIALOG)}
				onClose={handleDialogClose}
				refresh={doRefresh}
				sourceData={sourceData ? { clubPurchaseReceiptID: sourceData.clubPurchaseReceiptID ?? sourceData.purchaseReceiptID } : undefined}
			/>
			<PurchaseOrderCloseDialog open={isEqual(openDialog, PURCHASE_ORDER_CLOSE_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

PurchaseDialogBox.displayName = "PurchaseDialogBox";

export default PurchaseDialogBox;
